import "./ErrorPopup.scss";
import { useCallback } from "react";
import { exchangeActions } from "../../../store/reducers/exchange";
import Button from "components/Button/Button";
import { useAppSelector, useAppDispatch } from "store";
import { useTranslation } from "react-i18next";

const VerificationErrorPopup = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { verificationErorrHeader, verificationErrorText } = useAppSelector(
    (state) => state.exchange
  );
  const setIsOpenServerErrorPopup = useCallback(() => {
    dispatch(exchangeActions.setComponentsName("ExchangeCalculator"));
  }, [dispatch]);
  return (
    <div className="error-popup-container ">
      <div className="error-popup">
        <div className="error-popup-content verification-error">
          <div className="error-popup-header">{t(`popups.errorPopup.description.${verificationErorrHeader}`)}</div>
          <div className="error-popup-desc">{t(`popups.errorPopup.description.${verificationErrorText}`)}</div>
          <Button
            btnName="Cancel"
            className={"blue-btn"}
            onClick={setIsOpenServerErrorPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default VerificationErrorPopup;
